/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate, CheckboxCollapse, Checkbox, Label } from 'components';
import './style.scss';

function PreferenceSettings({
  preferenceLevel = 1,
  articlePreferences = [],
  contractGroupPreferences = [],
  onArticleChange = () => {},
  onContractGroupChange = () => {},
  onContractGroupArticleChange = () => {},
  checkArticleOfTypeDisable = () => {},
  showContent = false,
}) {
  const [secondView, setSecondView] = useState(false);
  const [previewState, setPreviewState] = useState(false);

  return (
    <div
      className={`tv-preference-setting__container ${
        previewState && 'tv-preference-setting__container--preview'
      }`}
    >
      <div className="tv-preference-setting__title">
        {Translate({ content: 'preference.title' })}
      </div>
      <p className="tv-preference-setting__content">
        {Translate({ content: 'preference.description' })}
      </p>
      {showContent ? (
        <>
          {!secondView && (
            <div className="tv-preference-setting__wrapper">
              {previewState && (
                <>
                  <div className="tv-preference-setting__title-2">
                    {Translate({ content: 'preference.previewTitle' })}
                  </div>
                  <p className="tv-preference-setting__content">
                    {Translate({ content: 'preference.previewDescription' })}
                  </p>
                </>
              )}

              <div className="tv-preference-setting__title-2">
                {Translate({ content: 'preference.question1' })}
              </div>

              <ArticlePreferences
                data={articlePreferences}
                onChange={onArticleChange}
              />
            </div>
          )}

          {preferenceLevel === 3 && secondView && (
            <div className="tv-preference-setting__wrapper">
              <div className="tv-preference-setting__title-2">
                {Translate({ content: 'preference.question3' })}
              </div>
              <CheckboxCollapse
                data={contractGroupPreferences}
                onArticleChange={onArticleChange}
                onContractGroupChange={onContractGroupChange}
                onContractGroupArticleChange={onContractGroupArticleChange}
                checkArticleOfTypeDisable={checkArticleOfTypeDisable}
              />
            </div>
          )}
          {preferenceLevel === 3 && previewState && (
            <div className="tv-preference-setting__wrapper">
              <div className="tv-preference-setting__title-2">
                {Translate({ content: 'preference.question3' })}
              </div>
              <ContaractGroupPreview
                data={contractGroupPreferences.filter(
                  x => x.IsDesiredByResource,
                )}
                checkArticleOfTypeDisable={checkArticleOfTypeDisable}
              />
            </div>
          )}
        </>
      ) : (
        <span>Kontakta TFV to have preference activate.</span>
      )}
    </div>
  );
}

PreferenceSettings.propTypes = {
  preferenceLevel: PropTypes.number,
  articlePreferences: PropTypes.arrayOf(PropTypes.shape({})),
  contractGroupPreferences: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PreferenceSettings;
function ArticlePreferences({ data = [] }) {
  return (
    <div className="mt-2">
      {data.map(subitem => (
        <Label className="d-flex flex-column" labelName={subitem.ArticleName} />
      ))}
    </div>
  );
}

function AreaOfBusinessPreferences({
  data = [],
  onChange = () => {},
  isPreview = false,
}) {
  return (
    <div>
      {data.map(subitem => (
        <Checkbox
          key={subitem.AreaOfBusinessName}
          text={subitem.AreaOfBusinessName}
          disabled={isPreview}
          inputName={subitem.AreaOfBusinessIdentifier}
          checked={subitem.IsDesiredByResource || false}
          onClick={() => {
            onChange(subitem.AreaOfBusinessIdentifier);
          }}
        />
      ))}
    </div>
  );
}

function ContaractGroupPreview({ data = [], checkArticleOfTypeDisable }) {
  return (
    <div>
      {data.map(item => (
      <div>
          <Checkbox
            text={item.ContractGroupName}
            disabled
            value={item.ContractGroupIdentifier}
            checked={item.IsDesiredByResource || false}
            onClick={e => {}}
          />
          <div className="tv-preference-setting__preview-article-container">
            {item.ContractGroupArticlePreferences.filter(
              x => x.IsDesiredByResource && !checkArticleOfTypeDisable(x),
            ).map(subitem => (
            <span>{subitem.ArticleName}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}


